"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdDefinition = void 0;
const zod_1 = require("zod");
const native_ad_1 = require("./native-ad");
exports.AdDefinition = zod_1.z
    .object({
    native: native_ad_1.NativeAd.optional(),
    fixedSize: zod_1.z.object({}).optional(),
    flexibleSize: zod_1.z.object({}).optional(),
    newMedia: zod_1.z.object({}).optional(),
})
    .refine(ad => Object.keys(ad).length === 1, {
    message: 'An ad must have exactly one type defined',
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYWQtZGVmaW5pdGlvbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9lbnRpdGllcy9hZC1kZWZpbml0aW9uLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLDZCQUF1QjtBQUV2QiwyQ0FBc0M7QUFFekIsUUFBQSxZQUFZLEdBQUcsT0FBQztLQUMxQixNQUFNLENBQUM7SUFDTixNQUFNLEVBQUUsb0JBQVEsQ0FBQyxRQUFRLEVBQUU7SUFDM0IsU0FBUyxFQUFFLE9BQUMsQ0FBQyxNQUFNLENBQUMsRUFBRSxDQUFDLENBQUMsUUFBUSxFQUFFO0lBQ2xDLFlBQVksRUFBRSxPQUFDLENBQUMsTUFBTSxDQUFDLEVBQUUsQ0FBQyxDQUFDLFFBQVEsRUFBRTtJQUNyQyxRQUFRLEVBQUUsT0FBQyxDQUFDLE1BQU0sQ0FBQyxFQUFFLENBQUMsQ0FBQyxRQUFRLEVBQUU7Q0FDbEMsQ0FBQztLQUNELE1BQU0sQ0FBQyxFQUFFLENBQUMsRUFBRSxDQUFDLE1BQU0sQ0FBQyxJQUFJLENBQUMsRUFBRSxDQUFDLENBQUMsTUFBTSxLQUFLLENBQUMsRUFBRTtJQUMxQyxPQUFPLEVBQUUsMENBQTBDO0NBQ3BELENBQUMsQ0FBQSJ9